import "../styles/UseCases.css";

const cases = [
  {
    cat: "Industrial manufacture",
    title: "Smarter manufacturing with AI",
    body: "We bring intelligence to manufacturing by combining predictive maintenance and advanced quality control. Our systems minimize downtime, prevent costly equipment failures, and keep products consistent. With real time monitoring and AI driven insight, manufacturers cut waste and stay competitive.",
  },
  {
    cat: "Stock exchange",
    title: "AI in financial markets",
    body: "Our financial systems give traders and institutions real time analytics and intelligent risk management. From millisecond trade analysis to volatility prediction, our models provide deep insight for smarter decisions, with forecasting and portfolio monitoring that reduce risk and grow returns.",
  },
  {
    cat: "IoT infrastructure",
    title: "Connecting the future with IoT",
    body: "We design and deploy IoT infrastructure that transforms cities and enterprises. From smart sensors that monitor traffic and energy to distributed edge computing, our systems ensure seamless connectivity and strong performance, unlocking efficiency, scalability, and sustainability.",
  },
];

function UseCases() {
  return (
    <main className="ix-page">
      <header className="ix-hero center">
        <div className="ix-shell">
          <span className="ix-eyebrow">Use cases</span>
          <h1>Real world solutions across industries.</h1>
          <p className="ix-hero-lead">
            Where our intelligence goes to work, from factory floors to financial
            markets to connected infrastructure.
          </p>
        </div>
      </header>

      <section className="ix-section">
        <div className="ix-shell">
          <div className="uc-list">
            {cases.map((c, i) => (
              <article className="uc-row" key={c.title}>
                <div className="uc-row-left">
                  <span className="uc-idx">{String(i + 1).padStart(2, "0")}</span>
                  <span className="front-cat">{c.cat}</span>
                </div>
                <div className="uc-row-body">
                  <h2 className="uc-title">{c.title}</h2>
                  <p>{c.body}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default UseCases;
